import { calculateScreen, MAXIMUM_HEIGHT, MAXIMUM_WIDTH, onScreenUpdate, updateHTMLElement, } from "common/screen";
import log from "loglevel";
export function letterbox(resizer) {
    log.debug("default letter box");
    updateHTMLElement.base({
        selectorParent: "#all-container",
        selectorChild: "#resizer",
    });
    setTimeout(() => {
        updateHTMLElement.base({
            selectorParent: "#all-container",
            selectorChild: "#resizer",
        });
        const allCon = $("#all-container")[0];
        const body = $("body")[0];
        if (body.scrollHeight !== allCon.scrollHeight) {
            window.scrollTo(0, body.scrollHeight - allCon.scrollHeight);
        }
        window.addEventListener("scroll", () => {
            if (body.scrollHeight !== allCon.scrollHeight) {
                window.scrollTo(0, body.scrollHeight - allCon.scrollHeight);
            }
        });
    }, 500);
    resizer.add(() => updateHTMLElement.base({
        selectorParent: "#all-container",
        selectorChild: "#resizer",
    }));
}
export { onScreenUpdate, MAXIMUM_HEIGHT, MAXIMUM_WIDTH, updateHTMLElement, calculateScreen, };
//# sourceMappingURL=screen.js.map